// -----------------  UPDATE PARENTAL CONTROL -----------------
export const PARENTAL_CONTROL_LOADING = 'PARENTAL_CONTROL_LOADING';
export const PARENTAL_CONTROL_SUCCESS = 'PARENTAL_CONTROL_SUCCESS';
export const PARENTAL_CONTROL_ERROR = 'PARENTAL_CONTROL_ERROR';

// -----------------  CLEAR PARENTAL CONTROL -----------------
export const CLEAR_PARENTAL_CONTROL_LOADING = 'CLEAR_PARENTAL_CONTROL_LOADING';
